import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "progress", "progressBar"]
  static values = { url: String, requiredItems: Array }

  async toggle(event) {
    const checkbox = event.currentTarget
    const itemName = checkbox.dataset.itemName
    const completed = checkbox.checked

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ item_name: itemName, completed: completed })
    })

    if (response.ok) {
      const data = await response.json()
      if (this.hasProgressTarget) {
        this.progressTarget.textContent = `${data.completion_count}/${data.total_items}`
      }
      if (this.hasProgressBarTarget) {
        this.progressBarTarget.style.width = `${data.completion_percentage}%`
      }
    }
  }

  validateRequired() {
    const incompleteItems = []
    this.itemTargets.forEach(item => {
      const checkbox = item.querySelector("input[type=checkbox]")
      const isRequired = this.requiredItemsValue.includes(checkbox?.dataset?.itemName)
      if (isRequired && !checkbox?.checked) {
        incompleteItems.push(checkbox.dataset.itemName)
      }
    })
    return { valid: incompleteItems.length === 0, incompleteItems }
  }

  checkBeforeTransition(event) {
    const result = this.validateRequired()
    if (!result.valid) {
      event.preventDefault()
      this.dispatch("blocked", {
        detail: {
          incompleteItems: result.incompleteItems,
          message: `Cannot proceed: ${result.incompleteItems.length} required checklist item(s) incomplete.`
        }
      })
    }
  }
}
